import React, {} from 'react'

import { useFrame} from 'react-three-fiber'
// import { Reflector } from '@react-three/drei'

import Handgame from './Handgame'



const Scene = (props) => {
    

    useFrame(()=>{

    })
    return (
            <group>
              <Handgame useStore={props.useStore} />
            </group>
       
    )
}

export default Scene